import RfiCategoryDrawerFile from './RfiCategoryDrawerFile.component';

export default RfiCategoryDrawerFile;
